import { defineMessages } from 'react-intl';

const trns = defineMessages({
  topSearchedDrugs: {
    id: 'zSzSpO',
    defaultMessage: 'ТОП пошуку'
  },
  alsoSearch: {
    id: 'hhX6Ax',
    defaultMessage: 'ТАКОЖ ШУКАЮТЬ'
  },
  sendButton: {
    id: 'f7wcVH',
    defaultMessage: 'Надіслати'
  },
  weCareAboutYourThoughts: {
    id: 'WXFy1R',
    defaultMessage: 'Ваша думка важлива для нас'
  }
});

export default trns;
